import { httpsCallable } from 'actions/firebase/functions'

export const validateRecaptcha = async (token) => httpsCallable('recaptchaValidate', { token })
